import { addressUtilsResolver } from "../../address/instance";
export function addressFormat(props) {
    const { address, network, providerName } = props;
    try {
        return addressUtilsResolver.addressFormat({ address, network, providerName });
    }
    catch (err) {
        return address;
    }
}
